module.exports = {
      id: "kishoralo-usage",
      viewBox: "0 0 512 209.434",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#kishoralo",
      toString: function () {
        return this.url;
      }
    }